module.exports = __webpack_public_path__ + "Roboto-Medium.fe13e4170719c2fc5865.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-Medium.ttf
// module id = 386
// module chunks = 2